import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExportControls = ({ reportTitle, onExport }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleExport = async (format) => {
    setIsExporting(true);
    try {
      await onExport?.(format);
      setTimeout(() => setIsExporting(false), 1500);
    } catch (error) {
      console.error('Export error:', error);
      setIsExporting(false);
    }
  };

  const handleShare = (method) => {
    console.log(`Sharing via ${method}`);
    setShowShareMenu(false);
  };

  const exportOptions = [
    {
      format: 'pdf',
      label: 'Exportar PDF',
      icon: 'FileDown',
      description: 'Documento optimizado para impresión'
    },
    {
      format: 'markdown',
      label: 'Descargar Markdown',
      icon: 'Download',
      description: 'Archivo .md editable'
    },
    {
      format: 'print',
      label: 'Imprimir',
      icon: 'Printer',
      description: 'Vista previa de impresión'
    }
  ];

  const shareOptions = [
    { method: 'email', label: 'Correo Electrónico', icon: 'Mail' },
    { method: 'link', label: 'Copiar Enlace', icon: 'Link' },
    { method: 'teams', label: 'Microsoft Teams', icon: 'MessageSquare' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
            <Icon name="Share2" size={20} color="var(--color-accent)" />
          </div>
          <h2 className="text-lg font-semibold font-mono">Controles de Exportación</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        {exportOptions?.map((option) => (
          <button
            key={option?.format}
            onClick={() => handleExport(option?.format)}
            disabled={isExporting}
            className="flex items-start gap-3 p-4 bg-background rounded-md border border-border hover:border-primary/50 hover:bg-muted/50 transition-all duration-250 focus-ring disabled:opacity-50 disabled:cursor-not-allowed text-left"
          >
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg flex-shrink-0">
              <Icon name={option?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">{option?.label}</p>
              <p className="text-xs text-muted-foreground caption">{option?.description}</p>
            </div>
          </button>
        ))}
      </div>
      <div className="relative">
        <Button
          variant="outline"
          fullWidth
          iconName="Share2"
          iconPosition="left"
          onClick={() => setShowShareMenu(!showShareMenu)}
        >
          Compartir Informe
        </Button>

        {showShareMenu && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-popover border border-border rounded-md shadow-lg overflow-hidden z-50">
            <div className="py-1">
              {shareOptions?.map((option) => (
                <button
                  key={option?.method}
                  onClick={() => handleShare(option?.method)}
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm text-foreground hover:bg-muted transition-all duration-250"
                >
                  <Icon name={option?.icon} size={16} />
                  <span>{option?.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExportControls;